

import React, { useEffect, useRef, useState } from 'react';
import WizardServices from './WizardServices';
import { EscalationRate } from '../ROYContract/Escalation';
import { PayOutRatePeriods } from '../ROYContract/payOutRatePeriods';
import DeleteDialogueBox from 'components/Common/deleteDialogue';
import { CommonUtilities } from 'commonUtils';

export function ContractWizardRates(MainWizard: any) {

    let [conAdditional, setcontractAdditional] = useState<any>([]);
    let [ratesBasis, setratesBasis] = useState<any>([]);
    let [systemUses, setsystemUses] = useState<any>([]);
    let [systemFormats, setsystemFormats] = useState<any>([]);
    let [editRate, seteditRate] = useState<any>([]);
    const formValidation = useRef<HTMLDivElement>(null);
    let [systemRegions, setsystemRegions] = useState<any>([]);

    let [payOutRatePeriods, SetpayOutRatePeriods] = useState<any>([]);
    let [EscalationSelect, SetEscalationSelect] = useState<any>([]);

    useEffect(() => {
        console.log(MainWizard.data.code)

        if (MainWizard.data.code) {

            WizardServices.contractscontractRefNum(MainWizard.data.contractRefNum).then((value: any) => {
                setcontractAdditional(value)
            })

            WizardServices.contractsratesBasis(MainWizard.data.code.contractRefNum).then((value: any) => {
                setratesBasis(value)
            })

            WizardServices.contractssystemUses(MainWizard.data.code.contractRefNum).then((value: any) => {
                setsystemUses(value)
            })

            WizardServices.contractssystemFormats({}).then((value: any) => {
                setsystemFormats(value)
            })

            WizardServices.contractssystemsystemRegions(MainWizard.data.code).then((value: any) => {
                setsystemRegions(value)
            })


        }
    }, []);

    const handleFieldChange = (e: any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;

        console.log(Field_value)
        console.log(Field_type)
        if (Field_type === "checkbox") {
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');

        let updatedObject = { ...editRate };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        }

        console.log(updatedObject);
        editRate = updatedObject;
        seteditRate(editRate);


    };

    const handleSpecificField = (fieldName: any, value: any, object: any) => {
        console.log(fieldName)
        console.log(object)
        console.log(value)

        let updatedObject = { ...editRate }
        if (fieldName === 'groupDesc,territoryCode') {
            var found = object.filter((event: any) => (event.groupDesc === (value)));
            updatedObject.groupDesc = found[0].groupDesc
            updatedObject.territoryCode = found[0].groupingId
        }

        if (fieldName === 'UsePriceDesc,usePrice') {
            var found = object.filter((event: any) => (event.value === (value)));
            updatedObject.UsePriceDesc = found[0] && found[0].value ? found[0].value : ''
            updatedObject.usePrice = found[0] && found[0].key ? found[0].key : ''
        }


        if (fieldName === 'formatDesc,format') {
            var found = object.filter((event: any) => (event.formatDesc === (value)));
            updatedObject.formatDesc = found[0].formatDesc
            updatedObject.format = found[0].codingStr
        }

        editRate = updatedObject;
        seteditRate(editRate);
    }

    const handleFieldRequired = (object: any) => {
        const inputs: any = formValidation.current?.querySelectorAll('input');
        var valid = true;

        Object.values(inputs).map((values: any) => {
            const isRequired = document.getElementById(values.id)?.hasAttribute('required');

            if (isRequired) {
                if (!object[values.id]) {
                    var fieldName: any = document.getElementById(values.id);
                    fieldName.style.border = "1px solid #ff0000";
                    valid = false;
                }
            }

        })
        return valid;
    }

    useEffect(() => {
        seteditRate(editRate)
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    }, [editRate]);

    const RateSave = () => {
        console.log(editRate)
        var validSave = handleFieldRequired(editRate);
        if (validSave) {
            WizardServices.ContractRateSave(MainWizard.data.code, editRate).then(() => {
                WizardServices.contractsratesBasis(MainWizard.data.code.contractRefNum).then((value: any) => {
                    setratesBasis(value)
                })
            })
        }
    }

    const closepayOutRatePeriods = () => {
        SetpayOutRatePeriods({})
    }
    const closeEscalation = () => {
        SetEscalationSelect({})
    }

    const RateReset = () => {
        editRate = {}
        seteditRate({ ...editRate })
    }

    const [Filter, setFilter] = useState("")

    let [deleteStatus, setDeleteStatus] = useState(false)
    let [deleteData, setdeleteData] = useState<any>([]);

    const deleteSelect = (e: any) => {
        deleteStatus = true;
        setDeleteStatus(deleteStatus)

        console.log(e)
        deleteData = e
        setdeleteData(deleteData)
    }

    const deleteConfirmation = (e: any) => {
        //e==1 YES
        if (e == 1) {
            WizardServices.contractsratesBasisDelete(MainWizard.data.code.contractRefNum, deleteData.ratesBasisID).then(() => { 
                CommonUtilities.CancelAPILoadingToast();
                CommonUtilities.showToastDawer("Delete Successful", "Success");

            })
        }
        //e==2 NO
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    }

    return (
        <>
            <div className="box ws-12 mb">

                <div className="box box-header ws-12 pull-left"> <h2>Contract Rate & Basis</h2>  </div>

                <div className='box-content ws-12' ref={formValidation}>

                    <div className="form-format ws-6 ptl">
                        <label className='text-bold ws-12'>Region*</label>
                        <div className="label-entries">
                            <select className='ws-11 full-height' value={editRate.groupDesc ?? ""} required
                                onChange={(e) => { handleSpecificField("groupDesc,territoryCode", e.target.value, systemRegions) }}>
                                <option value="">Choose region</option>

                                {systemRegions?.map((values: any, index: any) => {
                                    return (
                                        <option value={values.groupDesc} label={values.groupDesc} >{values.groupDesc}</option>
                                    )
                                })}

                            </select>
                        </div>
                    </div>

                    <div className="form-format ws-6 ptl">
                        <label className='text-bold' >Format/Source Codes*</label>
                        <div className="label-entries">
                            <select className='full-height' value={editRate.formatDesc ?? ""} required
                                onChange={(e) => { handleSpecificField("formatDesc,format", e.target.value, systemFormats) }}>
                                <option value="">Choose Format/Source Codes</option>
                                {
                                    systemFormats?.map((values: any, index: any) => {
                                        return (
                                            <option value={values.formatDesc} label={values.formatDesc} >{values.formatDesc}</option>
                                        )
                                    })
                                }

                            </select>
                        </div>
                    </div>

                    <div className="form-format ws-6 ptl">
                        <label className='text-bold ws-12'>Income Rate</label>
                        <div className="label-entries ws-10">
                            <input className="text-right" type="number" min="0" placeholder="Enter income rate" value={editRate.rate ?? ""} name="rate" onChange={(e) => handleFieldChange(e)} />
                        </div>
                    </div>

                    <div className="form-format ws-6 ptl">
                        <label className='text-bold ws-12'>Cost Rate</label>
                        <div className="label-entries">
                            <input className=" text-right ws-12 ml" value={editRate.costRate ?? ""} name="costRate" onChange={(e) => handleFieldChange(e)} type="number" min="0" placeholder="Enter Cost Rate" />
                        </div>
                    </div>

                    <div className="form-format ws-6 ptl">
                        <label className='text-bold ws-12'>Price Basis*</label>
                        <div className="label-entries">
                            <select className="ws-11" value={editRate.UsePriceDesc ?? ""} required
                                onChange={(e) => { handleSpecificField("UsePriceDesc,usePrice", e.target.value, systemUses) }}>
                                <option value="">Choose Price</option>
                                {
                                    systemUses?.map((values: any, index: any) => {
                                        return (
                                            <option value={values.value} label={values.value} >{values.value}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>

                <div className='box-footer ws-12'>
                    <button className="icon-btn delete width90 height35" onClick={RateReset} > Reset</button>
                    <button className="icon-btn edit width90 height35" onClick={RateSave}><i className="icon-save"></i> Save</button>
                </div>

            </div>

            <div className='box ws-12 mt'>
                <div className="box box-header">
                    <h2><i className="fa fa-table"></i>{ratesBasis.length} record(s) found</h2>
                </div>

                <div className="box-content">
                    <div className="box ws-12 hide"> Rates/Basis has been saved successfully </div>
                    <div className="box ws-12 hide"> Rates/Basis has been deleted successfully </div>

                    <div className="form-horizontal row-fluid" >
                        <div className="form-format ws-8 pbl">
                            <label className="ws-3 text-right pts mts pr " >Filter</label>

                            <div className="ws-9">
                                <input type="text" className="form-control ws-12 " placeholder="Search" id="rate" onChange={(e: any) => setFilter(e.target.value)} />
                            </div>
                        </div>
                    </div>

                    {(ratesBasis.length == 0) && <div className="alert alert-info" > No records to display </div>}

                    <div className="ws-12 allowVscroll">
                        <table className="table ws-12 forceSingleLine" >
                            <thead>
                                <tr>
                                    <th className='text-bold'>Region</th>
                                    <th className='text-bold'>Format Codes</th>
                                    <th className='text-bold'>Income Rate</th>
                                    <th className='text-bold'>Cost Rate</th>
                                    <th className='text-bold'>Price Basis</th>
                                    <th className='text-bold'>Price</th>
                                    <th className='text-bold'>Discount</th>
                                    <th className='text-bold'>Operation</th>
                                </tr>
                            </thead>
                            <tbody>

                                {ratesBasis?.filter((item: any) => Filter.length == 0 || item.groupDesc === Filter || item.formatDesc === Filter).map((values: any) => {

                                    return (

                                        <tr>
                                            <td> {values.groupDesc}</td>
                                            <td> {values.formatDesc}</td>
                                            <td className="text-right">{values.rate}</td>
                                            <td className="text-right">{values.costRate}</td>
                                            <td>{values.usePrice}</td>
                                            <td className="text-right">{values.price}</td>
                                            <td className="text-right">{values.discount}</td>
                                            <td style={{ width: "195px" }}>
                                                <a className="icon-btn edit" onClick={() => seteditRate(values)}><i className="icon-pencil"></i></a>
                                                <a className="icon-btn delete" onClick={() => deleteSelect(values)}><i className="icon-trashcan"></i></a>
                                                <a className="icon-btn info" title="Escalation" onClick={() => SetEscalationSelect(values)}><i className="icon-tasks"></i></a>
                                                <a className="icon-btn warning" title="Pay out rates for specific periods" onClick={() => SetpayOutRatePeriods(values)}><i className="icon-calculator2 warning"></i></a>
                                            </td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                    </div>
                </div>

                {(() => {

                    if (EscalationSelect && EscalationSelect.contractRefNum) {
                        return <EscalationRate closeEscalation={closeEscalation} data={EscalationSelect} openEscalation={true} />
                    }

                    if (payOutRatePeriods && payOutRatePeriods.contractRefNum) {
                        return <PayOutRatePeriods closepayOutRatePeriods={closepayOutRatePeriods} data={payOutRatePeriods} payOutRatePeriods={true} />
                    }
                    if (deleteStatus) {
                        return <DeleteDialogueBox param={deleteStatus} message={"delete region " + deleteData?.territoryCode} onChange={deleteConfirmation} />
                    }


                })()}
            </div>
        </>
    );
}
